import script from "./InspectorModel.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorModel.vue?vue&type=script&setup=true&lang=js"

import "./InspectorModel.vue?vue&type=style&index=0&id=0c08bd0c&lang=scss"

const __exports__ = script;

export default __exports__